import UserExplorerPage from '@playground/features/user-explorer/UserExplorerPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/')({
  // A partner admin reads no user data, so their home is the Partners page.
  beforeLoad: ({ context }) => {
    if (context.role.kind === 'partnerAdmin') {
      throw redirect({ to: '/promo-codes' })
    }
  },
  component: UserExplorerPage,
})
